import axios from '../utils/axiosInstance';

export const postEvaAgentAPI = async (data) => {
  const response = await axios.post('ReportConfiguration/', data);
  return response;
};
